// RepairTableStyles.ts
export const RepairTableStyles = {
  container: {
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    fontFamily: "Arial, sans-serif",
  },
  dateRangeContainer: {
    display: "flex",
    gap: "16px",
    marginBottom: "24px",
    alignItems: "center",
  },
  dateInputGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
  },
  dateLabel: {
    fontWeight: "600",
    fontSize: "14px",
    color: "#333",
    minWidth: "80px",
  },
  dateInput: {
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    flex: 1,
    backgroundColor: "#f9f9f9",
    transition: "border-color 0.3s, box-shadow 0.3s",
    outline: "none",
    ":focus": {
      borderColor: "#007bff",
      boxShadow: "0 0 0 3px rgba(0, 123, 255, 0.1)",
    },
  },
  responsiveView: {
    // Add responsive view styling
  },
  desktopView: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
    textAlign: "left",
  },
  th: {
    padding: "12px",
    backgroundColor: "#f8f9fa",
    borderBottom: "2px solid #dee2e6",
    fontWeight: "600",
    color: "#333",
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #dee2e6",
    color: "#555",
  },
  tr: {
    ":hover": {
      backgroundColor: "#f8f9fa",
    },
  },
  actionButton: {
    padding: "8px 12px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s, transform 0.2s",
    ":hover": {
      backgroundColor: "#0056b3",
      transform: "translateY(-1px)",
    },
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", 
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000, 
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
    width: "90%",
    maxWidth: "500px", 
    padding: "24px",
    position: "relative",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#333",
  },
  formGroup: {
    marginBottom: "16px",
  },
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "8px",
    color: "#555",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: "#f9f9f9",
    transition: "border-color 0.3s, box-shadow 0.3s",
    outline: "none",
    ":focus": {
      borderColor: "#007bff",
      boxShadow: "0 0 0 3px rgba(0, 123, 255, 0.1)",
    },
  },
  modalButtons: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "24px",
  },
  button: {
    padding: "10px 20px",
    borderRadius: "6px",
    border: "none",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.2s",
    ":hover": {
      transform: "translateY(-1px)",
    },
  },
};

export default RepairTableStyles;